/**
 * A styled TableResizer handle.
 */
import { styled } from "@insync-stageplayer/ui-components";
export const ColumnResizer = styled.div `
  cursor: col-resize;
  display: inline-block;
  width: 10px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(50%);
  z-index: 1;
  touch-action: none;
`;
//# sourceMappingURL=ColumnResizer.js.map